export default [
  {
    path: "/job/available",
    name: "AvailableJob",
    component: () => import("@/components/job/availableJob/AvailableJob"),
    meta: {
      title: "Pending Job Browser",
      requiresAuth: true,
      services: ["AvailableJob"]
    }
  },
  {
    path: "/job/available/:id",
    name: "AvailableJobDetail",
    component: () => import("@/components/job/availableJob/AvailableJobDetail"),
    meta: {
      requiresAuth: true,
      services: ["AvailableJob"]
    }
  },
  {
    path: "/job/tenant",
    name: "TenantJob",
    component: () => import("@/components/job/tenantJob/TenantJob"),
    meta: {
      title: "Tenant Job Browser",
      requiresAuth: true,
      services: ["TenantJob"]
    }
  },
  {
    path: "/job/tenant/:id",
    name: "TenantJobDetail",
    component: () => import("@/components/job/tenantJob/TenantJobDetail"),
    meta: {
      requiresAuth: true,
      services: ["TenantJob"]
    }
  },
  {
    path: "/job/tenant/repricing/:id",
    name: "Repricing",
    component: () => import("@/components/job/tenantJob/TenantJobRepricing"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/job/provider",
    name: "ProviderJob",
    component: () => import("@/components/job/providerJob/ProviderJob"),
    meta: {
      title: "Provider Job Browser",
      requiresAuth: true,
      services: ["ProviderJob"]
    }
  },
  {
    path: "/job/provider/:id",
    name: "ProviderJobDetail",
    component: () => import("@/components/job/providerJob/ProviderJobDetail"),
    meta: {
      requiresAuth: true,
      services: ["ProviderJob"]
    }
  },
  {
    path: "/job/provider/invoice/:id",
    name: "ProviderJobInvoice",
    component: () =>
      import("@/components/reservation/inquiry/ReservationInvoice"),
    meta: {
      requiresAuth: true,
      services: ["ProviderJob"]
    }
  },
  {
    path: "/job/driver",
    name: "DriverJob",
    component: () => import("@/components/job/driverJob/DriverJob"),
    meta: {
      title: "Driver Job Browser",
      requiresAuth: true,
      services: ["DriverJob"]
    }
  },
  {
    path: "/job/driver/:id",
    name: "DriverJobDetail",
    component: () => import("@/components/job/driverJob/DriverJobDetail"),
    meta: {
      requiresAuth: true,
      services: ["DriverJob"]
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/jobBrowserModule.js